import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';

import { catchError, Observable, of, switchMap } from 'rxjs';

import { Globals } from '@core/globals';
import { CarService } from '@services/car.service';
import { CarItem } from '@models/car.model';

export const carAaaidRevoler: ResolveFn<Observable<CarItem | null>> = (route) => {
  const router = inject(Router);
  const carService = inject(CarService);
  const globals = inject(Globals);
  const queryParamId = route.queryParamMap.get('aaaid');
  const paramId = route.paramMap.get('id');
  const carId = Number(paramId ?? queryParamId);
  const params = route.queryParams;

  return carService.getCarDataByAaaid(carId).pipe(
    switchMap((response) => {
      if (!response || !response.message?.items?.length) {
        router.navigate([globals.routes()['notFound'].url]);
        return of(null);
      }

      const car = response.message.items[0];
      if (car && car.make?.slug && car.model?.slug) {
        router.navigate([globals.routes()['detail'].url, car.make.slug, car.model.slug, car.id], { queryParams: { ...params } });
        return of(car);
      } else {
        router.navigate([globals.routes()['notFound'].url]);
        return of(null);
      }
    }),
    catchError(() => {
      router.navigate([globals.routes()['notFound'].url]);
      return of(null);
    }),
  );
};
